// Язык выбирается так же, как страна (см. shared/api/countryScope.js): значение
// лежит в localStorage, читается через валидацию и при мусоре в хранилище
// отдаёт безопасный дефолт.
export const LANGUAGE_STORAGE_KEY = "sorpaAdminLanguage";

// Русский остаётся языком интерфейса по умолчанию: админка полностью
// русифицирована (ENG-112), английский включается переключателем.
export const DEFAULT_LANGUAGE = "ru";

export const SUPPORTED_LANGUAGES = ["ru", "en"];

const supportedLanguage = (value) => {
    const normalized = String(value ?? "").trim().toLowerCase();
    return SUPPORTED_LANGUAGES.includes(normalized) ? normalized : null;
};

export const resolveAdminLanguage = (requestedLanguage) =>
    supportedLanguage(requestedLanguage) || DEFAULT_LANGUAGE;

export const getAdminLanguage = () => {
    try {
        return resolveAdminLanguage(localStorage.getItem(LANGUAGE_STORAGE_KEY));
    } catch {
        // Приватный режим и заблокированное хранилище не должны ронять админку.
        return DEFAULT_LANGUAGE;
    }
};

export const setAdminLanguage = (requestedLanguage) => {
    const nextLanguage = resolveAdminLanguage(requestedLanguage);
    try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, nextLanguage);
    } catch {
        // Выбор не сохранится, но интерфейс всё равно переключится.
    }
    window.dispatchEvent(
        new CustomEvent("sorpa-admin-language-change", {detail: {language: nextLanguage}}),
    );
    return nextLanguage;
};

export const clearAdminLanguage = () => {
    try {
        localStorage.removeItem(LANGUAGE_STORAGE_KEY);
    } catch {
        // Нечего чистить.
    }
};
